import { isBoxingZone, isCalisthenicZone } from '../../config';
import { Side, Zone } from '../../entities/gymschedule/zone';

export class StationAllocationOrderStrategies {
  public static fillUpFromStart = undefined; // default sort
  public static fillUpLeftSideFirst = (a: number, b: number) => {
    if (Zone.stationSide(a) === Side.Left &&  Zone.stationSide(b) === Side.Left) {
      return a - b;
    }
    if (Zone.stationSide(a) === Side.Right &&  Zone.stationSide(b) === Side.Right) {
      return a - b;
    }
    if (Zone.stationSide(a) === Side.Left) {
      return -1;
    }
    return 1;
  }

  public static fillUpCalisthenicThenLeftSideFirst = (a: [number, number], b: [number, number]) => {
    const [idA, zoneNumberA] = a;
    const [idB, zoneNumberB] = b;

    const sideA = Zone.stationSide(idA);
    const sideB = Zone.stationSide(idB);

    if (isCalisthenicZone(zoneNumberA) && !isCalisthenicZone(zoneNumberB)) {
      return -1;
    }
    if (!isCalisthenicZone(zoneNumberA) && isCalisthenicZone(zoneNumberB)) {
      return 1;
    }
    if (isBoxingZone(zoneNumberA) && !isBoxingZone(zoneNumberB)) {
      return -1;
    }
    if (!isBoxingZone(zoneNumberA) && isBoxingZone(zoneNumberB)) {
      return 1;
    }

    if (sideA === sideB) {
      return idA - idB;
    }

    return sideA === Side.Left ? -1 : 1;
  };

  public static getOnlyPriorityStations(
      freeStationsOrdered: number[], orderStrategy?: (a: number, b: number) => number) {
    if (orderStrategy === StationAllocationOrderStrategies.fillUpLeftSideFirst) {
      return freeStationsOrdered.filter((station) => Zone.stationSide(station) === Side.Left);
    }
    return freeStationsOrdered;
  }
}
